import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the MicroInsurancePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-micro-insurance',
  templateUrl: 'micro-insurance.html',
})
export class MicroInsurancePage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  next(type) {
    this.navCtrl.push('InsuranceSelectorPage', type);
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MicroInsurancePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/micro-insurance/micro-insurance.ts